// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"376":"86b08002","680":"f1dd3a79"}[chunkId] + ".chunk.css";
};